export const responsiveImageInputs = [
  {
    name: "alt",
    type: "string",
  },
  {
    name: "title",
    type: "string",
  },
  {
    name: "largeSrc",
    type: "file",
    required: true,
  },
  {
    name: "mediumSrc",
    type: "file",
  },
  {
    name: "smallSrc",
    type: "file",
  },
] as const satisfies Inputs;
